import { Locale } from '@ps-smart-cp/ppfw-client';
import { enumToName, rawValueToEnum } from '../utils';

/** 条件キー */
enum ConditionKey {
  /** 運用状態 */
  operationalStatus = '1',
  /** 更新時期 */
  updatePeriod = '2',
}

const nameConfig = {
  operationalStatus: new Map([
    [Locale.ja, '運用状態'],
    [Locale.en, 'Operation Status'],
  ]),
  updatePeriod: new Map([
    [Locale.ja, '更新時期'],
    [Locale.en, 'Update Period'],
  ]),
};

const toEnum = rawValueToEnum(ConditionKey, ConditionKey.operationalStatus);
const toDisplay = enumToName(ConditionKey, nameConfig);
const toDisplayWithPrefix = enumToName(ConditionKey, nameConfig, { prefix: true });

export const conditionKey = {
  enum: ConditionKey,
  nameConfig,
  toDisplay,
  toEnum,
  toDisplayWithPrefix,
};
export type { ConditionKey };
